// extracted by css-extract-rspack-plugin
export default {"pngIcon":"ZHt4gVpR","disabled":"utvw1gRr","rightMargin":"MD4scqch"};